import { createContext, Dispatch } from 'react'

/**
 * jwtの初期値
 */
export const initialJwtContext = ''

export const JwtContext = createContext<JwtContextProps>([
  initialJwtContext,
  (): void => {
    // 初期値として空の関数を設定
  },
])

export type JwtContextProps = [string, Dispatch<string>]
